module.exports = __webpack_public_path__ + "img/honor-bg.b0b50959.png";